
import React, { useEffect, useState } from 'react';
import { getregister, getmyprofile, getcaste, getdistrictslist } from "../action/user";
import { useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import swal from "sweetalert";
import FavoriteIcon from '@mui/icons-material/Favorite';
import config from "../../lib/config";
import { Button, MenuItem } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

function Freesearch() {

    const history = useNavigate();
    const location = useLocation();
    const [userValue, setUserValue] = useState([]);

    const search = useLocation().search;
    const [searchparamsf, setsearchparamsf] = useState(search);

    // console.log("fresdrw",search)
    var filterobj = "status=1";
    const castename = new URLSearchParams(search).get('castename');
    if (castename) {
        filterobj += "&castename=" + castename;
    }
    const religion = new URLSearchParams(search).get('religion');
    if (religion) {
        filterobj += "&religion=" + religion;
    }
    const subcaste = new URLSearchParams(search).get('subcaste');
    if (subcaste) {
        filterobj += "&subcaste=" + subcaste;
    }
    const sex = new URLSearchParams(search).get('sex');
    if (sex) {
        filterobj += "&sex=" + sex;
    }
    const maritalname = new URLSearchParams(search).get('maritalname');
    if (maritalname) {
        filterobj += "&maritalname=" + maritalname;
    }

    const c_date = new Date();
    let year = c_date.getFullYear();
    const age1 = new URLSearchParams(search).get('age1');
    if (age1) {
        const g_year = year - age1;

        filterobj += "&year[$lte]=" + g_year;
    }

    const age2 = new URLSearchParams(search).get('age2');
    if (age2) {
        const l_year = year - age2;

        filterobj += "&year[$gte]=" + l_year;
    }

    const [castes, setCastes] = useState([]);

    const getUserData = async () => {
        var test = await getmyprofile();
        setUserValue(test.userValue);
    }
    useEffect(() => {
        //logout(history)
        getUserData();
    }, []);
    const initialFormValue = {
        sex: "",
    };
    const [formValue, setFormValue] = useState(initialFormValue);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const sexch = [
        { title: "Male", value: "Male" },
        { title: "Female", value: "Female" },
    ];

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {

        // console.log(width);

        // console.log(height1);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValue(prev => ({ ...prev, [name]: value }));
    };
    const [validateError, setValidateError] = useState({});
    const [districts, setDistricts] = useState([]);

    const horoscopeTypes = [
        { value: "Matchmaking", label: "Matchmaking" },
        { value: "Life", label: "Life" },
    ];

    const agents = [
        { value: "KS001 - Rajesh Kumar", label: "KS001 - Rajesh Kumar" },
        { value: "KS002 - Priya Sharma", label: "KS002 - Priya Sharma" },
        { value: "KS003 - Arun Patel", label: "KS003 - Arun Patel" },
        { value: "KS004 - Sneha Reddy", label: "KS004 - Sneha Reddy" },
        { value: "KS005 - Vikram Singh", label: "KS005 - Vikram Singh" },
    ];

    useEffect(() => {
        const fetchData = async () => {
            const d = await getdistrictslist();
            const disOpts = d.userValue?.map(d => ({ title: d.city, value: d._id }));
            setDistricts(disOpts);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (location.state?.selectedAgent) {
            setFormValue(prev => ({
                ...prev,
                agent: location.state.selectedAgent.value
            }));
        }
    }, [location.state]);
    const handleSubmit = async () => {
        swal("Your Horoscope request submitted successfully.");
        setFormValue(prev => ({ ...prev, description: "" }));
    };
    return (
        <div style={{ marginTop: '30px' }}>
            <h2 className="font-great-vibes" style={{ margin: '0px 20px', color: '#B21919' }}>
                Request for Horoscope
            </h2>

            <div style={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
                <div style={{ margin: "1em 0", textAlign: "right" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => history(`/agent/list`)}
                        style={{
                            padding: "14px",
                            fontSize: "1.4rem",
                            fontWeight: "bold",
                            borderRadius: "6px",
                            background: "#B21919",
                            color: "#FFFFFF",
                        }}
                    >
                        Agents List
                    </Button>
                </div>
                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Full Name"
                        name="mname"
                        value={userValue?.mname || ""}
                        disabled
                        variant="filled"
                        InputLabelProps={{
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Email"
                        type="email"
                        name="email_id"
                        value={userValue?.email_id || ""}
                        disabled
                        variant="filled"
                        InputLabelProps={{
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Mobile Number"
                        name="mobile_number"
                        value={userValue?.mobile_number || ""}
                        disabled
                        variant="filled"
                        InputLabelProps={{
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        select
                        label="Horoscope Type"
                        name="horoscopeType"
                        value={formValue.horoscopeType || ""}
                        onChange={handleChange}
                        error={!!validateError.horoscopeType}
                        helperText={validateError.horoscopeType}
                        variant="standard"
                        InputLabelProps={{
                            shrink: true,
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        InputProps={{
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        SelectProps={{
                            style: {
                                marginTop: "22px",
                                textAlign: "left"
                            }
                        }}
                    >
                        {horoscopeTypes.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        select
                        label="Select Agent"
                        name="agent"
                        value={formValue.agent || ""}
                        onChange={handleChange}
                        error={!!validateError.agent}
                        helperText={validateError.agent}
                        variant="standard"
                        InputLabelProps={{
                            shrink: true,
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        InputProps={{
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        SelectProps={{
                            style: {
                                marginTop: "22px",
                                textAlign: "left"
                            }
                        }}
                    >
                        {agents.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={formValue.description || ""}
                        onChange={handleChange}
                        error={!!validateError.description}
                        helperText={validateError.description}
                        variant="standard"
                        multiline
                        rows={4}
                        InputLabelProps={{
                            shrink: true,
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>


                <div style={{ margin: "1em 0" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        fullWidth
                        style={{
                            padding: "14px",
                            fontSize: "1.4rem",
                            fontWeight: "bold",
                            borderRadius: "6px",
                            background: "#B21919",
                            color: "#FFFFFF"
                        }}
                    >
                        Request Horoscope
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Freesearch;
